import ButtonDelete from './ButtonDelete';
export default ButtonDelete;
